import {localizeRepContent} from './rep-content-locales';

const normalize = value => (value || '')
  .toString()
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .toLowerCase();

export const REP_GUIDES = [
  {
    key: 'registration',
    aliases: ['iscrizione', 'iscriversi', 'registrazione', 'registrarsi', 'creare account'],
    title: 'Come iscriversi a Replayer',
    summary: 'Puoi creare un account Replayer con email oppure usare Google o Apple.',
    steps: ['Apri la pagina di accesso e scegli Registrati.', 'Inserisci i dati richiesti oppure continua con Google o Apple.', 'Controlla la mail e attiva l’account dal collegamento ricevuto.', 'Accedi a Replayer e completa il profilo.'],
    route: '/sign-up-player',
    actionLabel: 'Apri la registrazione'
  },
  {
    key: 'share-highlight',
    aliases: ['condividere un highlight', 'condivido un highlight', 'link highlight', 'condividere highlight con un link', 'condividere uno spezzone', 'link dello spezzone', 'condividere una clip'],
    title: 'Come condividere un Highlight con un link',
    summary: 'Puoi generare un collegamento al tuo Highlight e condividerlo senza inviare direttamente il file originale.',
    steps: ['Apri My Video e vai nella tab Highlight.', 'Individua l’Highlight e premi Condividi.', 'Controlla le opzioni di visibilità disponibili.', 'Copia il collegamento generato e invialo alla persona che vuoi.', 'Se modifichi la visibilità o rimuovi il contenuto, verifica nuovamente che il collegamento sia ancora accessibile.'],
    route: '/player-video?section=highlight',
    actionLabel: 'Apri Highlight'
  },
  {
    key: 'highlight',
    aliases: ['highlight', 'creare highlight', 'creare uno spezzone', 'creare spezzone', 'creare una clip', 'fare un taglio', 'ritagliare un video', 'creare un estratto'],
    title: 'Come creare un Highlight',
    summary: 'Ritaglia un’azione da un Replayer Video indicando il punto di inizio e quello di fine.',
    steps: ['Apri My Video e vai in Replayer video.', 'Scegli il video completo e premi Highlight.', 'Durante la riproduzione premi Inizio sul primo istante e Fine sull’ultimo.', 'Se serve, correggi manualmente gli orari e controlla la durata.', 'Inserisci titolo e descrizione, quindi salva.'],
    route: '/player-video?section=video',
    actionLabel: 'Apri Replayer video'
  },
  {
    key: 'tag',
    aliases: ['tag', 'creare tag', 'etichetta video'],
    title: 'Come creare e usare i Tag',
    summary: 'I Tag aiutano a ritrovare rapidamente azioni e momenti nei tuoi video.',
    steps: ['Apri My Video e seleziona Tag.', 'Crea o modifica le etichette che vuoi utilizzare.', 'Apri un Replayer Video e premi Tag.', 'Associa i tag ai momenti del video e salva.', 'Torna nella sezione Tag per cercare i contenuti etichettati.'],
    route: '/player-video?section=tags',
    actionLabel: 'Apri Tag'
  },
  {
    key: 'folders',
    aliases: ['organizzare video in cartelle', 'organizzo video', 'dividere video in cartelle', 'cartelle video', 'cartelle highlight', 'video e highlight in cartelle'],
    title: 'Come organizzare video e Highlight in cartelle',
    summary: 'Le cartelle ti aiutano a separare partite, allenamenti e momenti preferiti senza modificare o duplicare il contenuto originale.',
    steps: ['Apri My Video e scegli Replayer video oppure Highlight.', 'Nella sezione di organizzazione inserisci il nome della nuova cartella e premi Crea.', 'Sulla card del contenuto apri Archivia in e scegli la cartella.', 'Usa il filtro Visualizza per mostrare soltanto i contenuti della raccolta scelta.', 'Puoi cambiare cartella in seguito senza modificare il video o l’Highlight.'],
    route: '/player-video?section=video',
    actionLabel: 'Organizza My Video'
  },
  {
    key: 'planning',
    aliases: ['pianificare campo', 'pianificazione campo', 'creare slot', 'pianificare uno slot', 'pianifica campo'],
    title: 'Come pianificare un campo',
    summary: 'La pianificazione definisce quando un campo è disponibile, riservato e con quali regole.',
    steps: ['Accedi come Partner e apri Risorse.', 'Scegli il campo e premi Pianifica.', 'Trascina sul calendario l’intervallo da creare.', 'Scegli slot disponibile o riservato e configura posti, prezzi e video.', 'Controlla il riepilogo e salva lo slot.'],
    route: '/partner-fields',
    actionLabel: 'Apri Risorse'
  },
  {
    key: 'playlist',
    aliases: ['playlist', 'creare playlist'],
    title: 'Come creare una Playlist',
    summary: 'Raccogli più highlight compatibili in un unico contenuto da riprodurre o esportare.',
    steps: ['Apri My Video e vai in Highlight.', 'Seleziona almeno due highlight con camera compatibile.', 'Premi Crea playlist.', 'Assegna nome e descrizione e conferma.', 'Troverai il risultato nella tab Playlist.'],
    route: '/player-video?section=playlist',
    actionLabel: 'Apri Playlist'
  },
  {
    key: 'analysis',
    aliases: ['analisi', 'analizzare video', 'analisi video', 'analisi pickleball', 'pb vision', 'fasi analisi', 'taglio del video'],
    title: 'Come richiedere un’Analisi Pickleball',
    summary: 'Per i video di Pickleball compatibili, Replayer prepara lo spezzone scelto e lo invia al servizio di analisi. Costo e disponibilità vengono sempre mostrati prima della conferma.',
    steps: [
      'Apri un video di Pickleball compatibile da My Video, ReplayerTV o Video Store e premi Analisi. Il pulsante appare soltanto quando l’analisi è configurata per quel contenuto.',
      'Riproduci il video e indica Inizio e Fine dello spezzone. Per ottenere un risultato coerente, seleziona dal primo punto all’ultimo punto di un set; la durata massima prevista è 30 minuti.',
      'Aggiungi titolo e descrizione, scegli la camera disponibile e controlla durata, costo calcolato e credito Replayer.',
      'Conferma il pagamento. Se il credito non basta, ricarica il wallet e torna alla richiesta senza dover scegliere di nuovo il video.',
      'La richiesta compare in My Video, nella tab Analisi. Nelle prime fasi Replayer attende il filmato, genera il taglio selezionato e prepara il file.',
      'Quando il taglio è pronto viene messo in coda e poi elaborato dal provider. Dopo l’invio al provider o durante l’elaborazione la richiesta non può più essere annullata.',
      'Quando l’analisi è disponibile ricevi una comunicazione e puoi aprire il risultato in Replayer e, quando previsto, in PB Vision; puoi inoltre condividerlo.',
      'Se l’elaborazione non può essere completata, lo stato indica l’errore. Quando la richiesta risulta rimborsata, il costo è stato riaccreditato nel wallet Replayer.'
    ],
    route: '/player-video?section=analysis',
    actionLabel: 'Apri Analisi'
  },
  {
    key: 'dedicated-page',
    aliases: ['pagina dedicata', 'pagina del circolo', 'pagina pubblica del circolo', 'sito del circolo su replayer'],
    title: 'Cos’è una pagina dedicata',
    summary: 'È lo spazio pubblico personalizzato di un Centro Sportivo dentro Replayer, raggiungibile con un indirizzo specifico e riconoscibile con identità, informazioni e servizi del circolo.',
    steps: [
      'Presenta il Centro Sportivo con nome, logo, immagini, descrizione, contatti e informazioni aggiornate.',
      'Riunisce in un unico punto soltanto le funzioni abilitate dal centro, come prenotazione dei campi, ReplayerTV, eventi e shop.',
      'Permette agli utenti di conoscere il circolo e passare direttamente all’azione disponibile senza cercare le varie sezioni di Replayer.',
      'Il Partner aggiorna contenuti e risorse dalle proprie aree di gestione; l’attivazione e l’indirizzo pubblico della pagina dipendono dalla configurazione Replayer.',
      'Non è una pagina separata dai servizi: prezzi, disponibilità, video e prodotti continuano a seguire le regole configurate dal circolo.'
    ],
    route: '/player-show-sport-centers',
    actionLabel: 'Scopri i Centri Sportivi'
  },
  {
    key: 'booking',
    aliases: ['prenotazione', 'prenotare campo', 'prenotazione a invito', 'invitare partecipante', 'invitare ospite'],
    title: 'Come prenotare un campo',
    summary: 'Cerca uno slot, completa gli eventuali partecipanti obbligatori e conferma soltanto dopo il riepilogo dei costi.',
    steps: ['Apri Centri sportivi e scegli un circolo prenotabile.', 'Seleziona campo, giorno e slot.', 'Per gli slot a invito aggiungi partecipanti Replayer o ospiti.', 'Controlla chi paga, sconti, costi fissi e totale.', 'Conferma la prenotazione e ritrovala in Le mie prenotazioni.'],
    route: '/player-show-sport-centers?bookable=true',
    actionLabel: 'Trova un campo'
  },
  {
    key: 'topup',
    aliases: ['ricarica', 'ricaricare credito', 'credito replayer', 'wallet'],
    title: 'Come ricaricare il credito',
    summary: 'Scegli l’importo e il metodo di pagamento; il credito sarà disponibile nel wallet dopo la conferma.',
    steps: ['Apri la pagina Ricarica credito.', 'Inserisci un importo di almeno 5 €.', 'Scegli uno dei metodi disponibili.', 'Conferma nel servizio di pagamento.', 'Torna in Replayer e verifica il nuovo saldo.'],
    route: '/user-top-up-account',
    actionLabel: 'Apri Ricarica credito'
  }
];

export const findRepGuide = (query, language = 'it') => {
  const normalized = normalize(query);
  const matches = REP_GUIDES.map(guide => localizeRepContent(guide, 'guides', language)).reduce((result, guide) => {
    const aliases = guide.aliases.filter(alias => normalized.includes(normalize(alias)));
    if (!aliases.length) return result;
    const specificity = Math.max(...aliases.map(alias => normalize(alias).length));
    return [...result, {guide, specificity}];
  }, []);
  matches.sort((first, second) => second.specificity - first.specificity);
  return matches.length ? matches[0].guide : null;
};
